import { render } from "./CoohomeIframe.vue?vue&type=template&id=543daad5&scoped=true"
import script from "./CoohomeIframe.vue?vue&type=script&lang=js"
export * from "./CoohomeIframe.vue?vue&type=script&lang=js"

import "./CoohomeIframe.vue?vue&type=style&index=0&id=543daad5&scoped=true&lang=css"

import exportComponent from "/Users/john/Desktop/projects/vue_js_projects/portfolio-tailwind/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-543daad5"]])

export default __exports__